// The Master Data guide (27_MasterData.jsx · ModuleHelp, Max 01/11).
const en = {
  listT: 'The catalogues',
  listB: 'The shared lists the portal screens draw their dropdowns from, grouped by area. The number is how many values each one holds; click one to open it.',
  btnsT: 'Reload and add',
  btnsB: 'Refresh reloads the open catalogue. Add value starts a new row at the top of the table.',
  searchT: 'Search the values',
  searchB: 'Type to narrow the table to matching values. The count beside it says how many are showing.',
  tableT: 'The values',
  tableB: 'Click a column title to sort. Used shows how many records point at a value; Active says whether it still appears in dropdowns.',
  rowT: 'Edit or delete',
  rowB: 'Edit changes the value in place. A value that records still use cannot be deleted, so switch it off instead.',
};
const ko = {
  listT: '카탈로그',
  listB: '포털 화면의 드롭다운이 가져다 쓰는 공용 목록이며 영역별로 묶여 있습니다. 숫자는 각 목록의 값 개수이고, 클릭하면 열립니다.',
  btnsT: '새로고침과 추가',
  btnsB: '새로고침은 열려 있는 카탈로그를 다시 불러옵니다. 값 추가는 표 맨 위에 새 행을 만듭니다.',
  searchT: '값 검색',
  searchB: '입력하면 일치하는 값만 표에 남습니다. 옆의 건수는 현재 표시된 개수입니다.',
  tableT: '값 목록',
  tableB: '열 제목을 클릭하면 정렬됩니다. 사용 열은 그 값을 참조하는 레코드 수이고, 활성은 드롭다운에 계속 나오는지를 나타냅니다.',
  rowT: '수정 또는 삭제',
  rowB: '수정은 그 자리에서 값을 바꿉니다. 레코드가 사용 중인 값은 삭제할 수 없으니 대신 비활성으로 바꾸세요.',
};
const vi = {
  listT: 'Các danh mục',
  listB: 'Những danh sách dùng chung mà các màn hình portal lấy làm dropdown, gom theo khu vực. Con số là số giá trị trong mỗi danh mục; bấm vào để mở.',
  btnsT: 'Tải lại và thêm',
  btnsB: 'Làm mới tải lại danh mục đang mở. Thêm giá trị tạo một dòng mới ở đầu bảng.',
  searchT: 'Tìm giá trị',
  searchB: 'Gõ để bảng chỉ còn các giá trị khớp. Số bên cạnh cho biết đang hiển thị bao nhiêu giá trị.',
  tableT: 'Các giá trị',
  tableB: 'Bấm tiêu đề cột để sắp xếp. Cột Đã dùng là số bản ghi đang trỏ tới giá trị đó; Hoạt động cho biết giá trị còn hiện trong dropdown hay không.',
  rowT: 'Sửa hoặc xóa',
  rowB: 'Sửa đổi giá trị ngay tại chỗ. Giá trị đang có bản ghi dùng thì không xóa được, hãy tắt hoạt động thay vì xóa.',
};
const zh = {
  listT: '目录',
  listB: '门户各页面下拉框所使用的公共列表，按领域分组。数字是每个目录中的值的数量，点击即可打开。',
  btnsT: '刷新与新增',
  btnsB: '刷新会重新加载当前打开的目录。新增值会在表格顶部添加一行新记录。',
  searchT: '搜索值',
  searchB: '输入文字，表格只保留匹配的值。旁边的计数显示当前显示的数量。',
  tableT: '值列表',
  tableB: '点击列标题可排序。“已使用”表示有多少记录引用了该值；“启用”表示它是否还出现在下拉框中。',
  rowT: '编辑或删除',
  rowB: '编辑会就地修改该值。仍被记录使用的值不能删除，请改为停用。',
};
// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "listT": "Les catalogues",
  "listB": "Les listes partagées dans lesquelles les écrans du portail puisent leurs listes déroulantes, regroupées par domaine. Le nombre indique combien de valeurs chacune contient ; cliquez sur une liste pour l'ouvrir.",
  "btnsT": "Recharger et ajouter",
  "btnsB": "Actualiser recharge le catalogue ouvert. Ajouter une valeur crée une nouvelle ligne en haut du tableau.",
  "searchT": "Rechercher les valeurs",
  "searchB": "Saisissez du texte pour réduire le tableau aux valeurs correspondantes. Le compteur à côté indique combien sont affichées.",
  "tableT": "Les valeurs",
  "tableB": "Cliquez sur un titre de colonne pour trier. Utilisé indique combien d'enregistrements pointent vers une valeur ; Actif indique si elle apparaît encore dans les listes déroulantes.",
  "rowT": "Modifier ou supprimer",
  "rowB": "Modifier change la valeur sur place. Une valeur encore utilisée par des enregistrements ne peut pas être supprimée ; désactivez-la plutôt."
};
const ja = {
  "listT": "カタログ",
  "listB": "ポータルの各画面がドロップダウンの選択肢を取得する共有リストを、エリア別にまとめています。数字は各リストの値の数です。クリックして開きます。",
  "btnsT": "再読み込みと追加",
  "btnsB": "「更新」で開いているカタログを再読み込みします。「値を追加」で、表の先頭に新しい行を作成します。",
  "searchT": "値を検索",
  "searchB": "文字を入力すると、一致する値だけに表を絞り込みます。横の件数は表示中の数です。",
  "tableT": "値",
  "tableB": "列見出しをクリックして並べ替えます。「使用数」は値を参照しているレコード数、「有効」はドロップダウンに引き続き表示されるかどうかを示します。",
  "rowT": "編集または削除",
  "rowB": "「編集」でその場で値を変更します。レコードが使用中の値は削除できないため、代わりに無効にしてください。"
};

const dictionary = { ns: 'tourMasterData', en, ko, vi, zh, fr, ja };
export default dictionary;
